import { ArrowLeft, X } from "lucide-react";
import { Button } from "../ui/button";
import type { SheetType } from "@/zustand/sheetStore";

interface SheetControlButtonProps {
  currentStep?: number | null;
  setStep?: (step: number) => void;
  closeSheet: () => void;
  sheet?: SheetType;
}

const SheetControlButton: React.FC<SheetControlButtonProps> = ({
  currentStep = 1,
  setStep,
  closeSheet,
  sheet,
}) => {
  const isFirstStep = currentStep === 1;
  const handleClick = () => {
    if (isFirstStep) {
      closeSheet();
    } else if (
      sheet === "send-fiat" &&
      (currentStep === 3 || currentStep === 4)
    ) {
      setStep?.(2);
    } else {
      setStep?.((currentStep as number) - 1);
    }
  };

  return (
    <Button
      type="button"
      variant="secondary"
      size="icon"
      // `secondary` resolves to #181818 in the user-side scope — the same
      // colour as the sheet background, which made this control invisible. The
      // border is what separates it from the surface. See docs/WAVE-1.md step 5.
      className="border-dark-stroke-3 text-dark-text-100 absolute top-2 left-2 border"
      onClick={handleClick}
    >
      {isFirstStep ? <X /> : <ArrowLeft />}
    </Button>
  );
};

export default SheetControlButton;
